let BASE_URL = 'https://api.boltinsight.com/'; // PROD ENVIRONMENT
let BASE_CUSTOMER_APP_URL = 'https://app.boltinsight.com/';
let SURVEY_URL = 'https://survey.boltinsight.com/';
let RECRUITMENT_URL = 'https://recruitapi.boltinsight.com/';
let RECRUITMENT_URL_PROD = 'https://recruitapi.boltinsight.com/';
let ENV = 'prod';

if (process.env.REACT_APP_ENV === 'dev') {
  // DEV ENVIRONMENT
  BASE_URL = 'https://api-dev.boltinsight.com/';
  BASE_CUSTOMER_APP_URL = 'https://app-dev.boltinsight.com/';
  SURVEY_URL = 'https://survey-dev.boltinsight.com/';
  RECRUITMENT_URL = ' https://recruitapi-dev.boltinsight.com/';
  ENV = 'dev';
}

if (process.env.NODE_ENV === 'development') {
  // DEV ENVIRONMENT

  if (process.env.REACT_APP_ENV === 'local') {
    BASE_URL = 'http://localhost:8080/';
    RECRUITMENT_URL = 'http://localhost:3001/';
  } else {
    RECRUITMENT_URL = ' https://recruitapi-dev.boltinsight.com/';
    BASE_URL = 'https://api-dev.boltinsight.com/';
  }

  BASE_CUSTOMER_APP_URL = 'https://app-dev.boltinsight.com/';
  SURVEY_URL = 'https://survey-dev.boltinsight.com/';

  ENV = 'dev';
}

export const SERVER_URL = `${BASE_URL}admin-api/0.0/`;
export {
  BASE_CUSTOMER_APP_URL,
  SURVEY_URL,
  RECRUITMENT_URL,
  ENV,
  RECRUITMENT_URL_PROD,
};
